const merge = (t, s) => {
  try {
    const o = Object,
      a = o.assign;
    for (const k of o.keys(s)) {
      if (Array.isArray(s[k])) t[k] = s[k];
      else s[k] instanceof o && a(s[k], merge(t[k], s[k]));
    }
    return a(t || {}, s), t;
  } catch (e) {
    console.dir({ t, s });
    console.error(e);
  }
};

export default {
  createTickerMatches({ commit }, result) {
    if (!result || !result.length) return;
    result.forEach(row => {
      commit("createTickerMatch", {
        _id: row._id,
        match: row.data
      });
    });
  },
  deleteTickerMatches({ commit }, result) {
    if (!result || !result.length) return;
    result[0].forEach(_id => {
      commit("deleteTickerMatch", _id);
    });
  },
  fetchTickerMatches({ commit }, matches) {
    commit("tickerMatches", matches);
  },
  updateTickerMatches({ state, commit }, result) {
    if (!result || !result.length) return;
    result.forEach(row => {
      const match = state.ticker.matches.find(({ _id }) => row._id === _id);
      if (!match) return;
      ["home", "away"].forEach(key => {
        const scoreKey = `${key}Score`;
        const activeKey = `${key}Active`;
        // eslint-disable-next-line fp/no-mutation
        match[activeKey] =
          row.data[scoreKey] !== undefined
            ? match[scoreKey] !== row.data[scoreKey]
            : false;
      });
      commit("updateTickerMatch", {
        _id: row._id,
        match: merge(match, row.data)
      });
    });
  }
};
